/**
 * Derive the "last activity" timestamp for a single linked child.
 *
 * Scans `childData.questionStates[*].history[*].timestamp` and returns the
 * most recent attempt time, or `null` when the child has no recorded
 * practice yet.
 *
 * Used by the parent portal's `<DataFreshness />` chip to show a truthful
 * sync signal instead of `Date.now()` (D-P2, see PARENT_PORTAL_PLAN_2026.md).
 *
 * Note: ComparePage previously inlined this loop per-child to compute its
 * `lastActivityTs`. It now consumes this helper so all parent surfaces share
 * a single source of truth.
 */
import { AppState } from '../../../app/types'

export function getChildLastActivity(
  childData: AppState | null | undefined,
): number | null {
  if (!childData?.questionStates) return null
  let max: number | null = null
  for (const state of Object.values(childData.questionStates)) {
    const history = state?.history
    if (!history || history.length === 0) continue
    for (const attempt of history) {
      if (!attempt) continue
      const ts = attempt.timestamp
      if (typeof ts !== 'number') continue
      if (max === null || ts > max) max = ts
    }
  }
  return max
}
